// components/FormattedMessage.jsx
import React from 'react';

export const FormattedMessage = ({ content }) => {
  if (!content || typeof content !== 'string') return null;
  const parts = content.split(/(```[\s\S]*?```)/g);
  return (
    <div className="space-y-2 leading-relaxed text-[13px]">
      {parts.map((part, index) => {
        if (part.startsWith('```')) {
          const code = part.replace(/```/g, '').trim();
          return (
            <pre key={index} className="bg-black/60 p-4 rounded-2xl border border-gray-200 font-mono text-[11px] text-red-500 overflow-x-auto my-3 shadow-inner">
              <code>{code}</code>
            </pre>
          );
        }
        const lines = part.split('\n');
        return lines.map((line, lIdx) => {
          const trimmedLine = line.trim();
          if (!trimmedLine && lIdx !== 0) return <div key={lIdx} className="h-2" />;
          const isListItem = trimmedLine.startsWith('- ') || trimmedLine.startsWith('* ');
          const contentLine = isListItem ? trimmedLine.substring(2) : line;
          const formattedLine = contentLine.split(/(\*\*.*?\*\*)/g).map((subPart, sIdx) => {
            if (subPart.startsWith('**') && subPart.endsWith('**')) {
              return <strong key={sIdx} className="text-gray-900 font-black">{subPart.slice(2, -2)}</strong>;
            }
            return subPart;
          });
          return (
            <div key={`${index}-${lIdx}`} className={`${isListItem ? 'pl-5 relative mb-1' : 'mb-1'} min-h-[1.2em]`}>
              {isListItem && <span className="absolute left-0 text-red-600 font-bold">•</span>}
              {formattedLine}
            </div>
          );
        });
      })}
    </div>
  );
};